"use client";

import { type ReactNode } from "react";
import { useWorkspaceTheme } from "@/hooks/use-workspace-theme";

export function AppThemeProvider({ children }: { children: ReactNode }) {
  useWorkspaceTheme();
  return children;
}
